import validations from '~/helpers/validations'

const regexRuleNames: ValidationFormat[] = ['phone']

interface Field {
  required: boolean
  format: ValidationFormat
}

type ValidationFormat = string | null

function getFieldValidationRules ({ required, format }: Field) {
  return {
    required,
    regex: regexRuleNames.includes(format) ? getRegexFromFormat(format) : false,
    numeric: format === 'number'
  }
}

function getRegexFromFormat (format: ValidationFormat) {
  switch (format) {
    case 'phone':
      return validations.PHONE_NUMBER
    case null:
      return false
    default:
      return false
  }
}

export default getFieldValidationRules
